import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import View from '@/components/view'
import Home from '@/components/home/home'//首页
import Google from '@/components/system/google'//谷歌登录信息设置
import Coin from '@/components/system/coin'//币种设置
import Banner from '@/components/system/banner'//banner
import Level from '@/components/system/level'//等级设置
import Agent from '@/components/agent/agent'//代理管理
import User from '@/components/user/user'//用户管理
import Pay from '@/components/system/pay'//支付通道
import Manager from '@/components/manager/manager'//用户管理
import Bank from '@/components/bank/bank'//订单文字提醒
import Order from '@/components/order/order'//订单管理
import Transaction from '@/components/transaction/transaction'//用户管理
import Announcement from '@/components/announcement/announcement'//借款列表
import Notice from '@/components/notice/notice'//合同
import Deposit from '@/components/deposit/deposit'//生成打款截图
import Withdraw from '@/components/withdraw/withdraw'//管理员管理
import Admin from '@/components/admin/admin'//代理管理
import Normal from '@/components/system/normal'//代理管理
import Kefu from '@/components/kefu/kefu'//代理管理

Vue.use(Router)

export default new Router({
	mode: 'hash',
	base:'/admin',
	routes: [
		{
			path: '/',
			redirect: '/login',
			component: Login
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/view',
			name: 'view',
			component: View,
			children: [
				{
					path: '/home',
					name: 'home',
					component: Home
				},
				{
					path: '/coin',
					name: 'coin',
					component: Coin
				},
				{
					path: '/banner',
					name: 'banner',
					component: Banner
				},
        {
        	path: '/level',
        	name: 'level',
        	component: Level
        },
				{
					path: '/manager',
					name: 'manager',
					component: Manager
				},
				{
					path: '/google',
					name: 'google',
					component: Google
				},
				{
					path: '/order',
					name: 'order',
					component: Order
				},
				{
					path: '/user',
					name: 'user',
					component: User
				},
				{
					path: '/announcement',
					name: 'announcement',
					component: Announcement
				},
				{
					path: '/agent',
					name: 'agent',
					component: Agent
				},{
					path: '/transaction',
					name: 'transaction',
					component: Transaction
				},
				{
					path: '/bank',
					name: 'bank',
					component: Bank
				},
				{
					path: '/pay',
					name: 'pay',
					component: Pay
				},
				{
					path: '/withdraw',
					name: 'withdraw',
					component: Withdraw
				},
				{
					path: '/deposit',
					name: 'deposit',
					component: Deposit
				},
				{
					path: '/notice',
					name: 'notice',
					component: Notice
				},
				{
					path: '/admin',
					name: 'admin',
					component: Admin
				},
				{
					path: '/normal',
					name: 'normal',
					component: Normal
				},
				{
					path: '/kefu',
					name: 'kefu',
					component: Kefu
				}
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js